import { Box, Link, Stack, styled } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { FC, useEffect, useState } from 'react';
import { IJobCandidateInteractionResponse, IJob, getSubmissionSettings } from 'wisestep-api';
import {
  Item,
  TextOnLine,
  ActivityCard,
  WsTypography,
  WsColors,
  Button,
  IUserDTO,
} from 'wisestep-base';

import { useUserContext } from '../../../context';

type ColorType = {
  bgColor: string;
  noWidth?: boolean;
};

export const SwitchButton = styled(Button)(({ bgColor, noWidth }: ColorType) => ({
  backgroundColor: bgColor,
  width: noWidth ? 'auto' : '150px',
  border: '0.2px solid',
  borderRadius: 0,
}));

interface ISubmissionHistory {
  totalConversation: string | null;
  history: IJobCandidateInteractionResponse | null;
  conversations: IJobCandidateInteractionResponse[];
  onSubmissionStatusUpdate?: (interactionId: string | null) => void;
  onActivityUpdate?: (interactionId: string | null) => void;
  onLoadMore: () => void;
  onClickOnJobCode?: (jobId: string) => void;
  loadHistory: (id: string) => void;
  taskLisiting?: JSX.Element;
  isInDnc?: boolean;
  showJobRealtedConverationOnTop?: string | null;
  selectedJob?: IJob | null;
  currentJobCode?: string | null;
  jobAdminTeam?: boolean;
}
const SubmissionHistory: FC<ISubmissionHistory> = ({
  conversations,
  history,
  onSubmissionStatusUpdate,
  totalConversation,
  onLoadMore,
  onClickOnJobCode,
  loadHistory,
  onActivityUpdate,
  taskLisiting,
  isInDnc = false,
  currentJobCode,
  jobAdminTeam,
}) => {
  const [submissions, setSubmissions] = useState<IJobCandidateInteractionResponse[]>([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [planIndex, setPlanIndex] = useState<number>(0);
  const currentSubmission = conversations.filter((candidate: IJobCandidateInteractionResponse) => {
    return (
      candidate.jobCode === currentJobCode && candidate.candidateStatusTags.includes('submitted')
    );
  });

  const loggedInUser = useUserContext().userDTO as IUserDTO;
  useEffect(() => {
    setSubmissions(
      conversations.filter((candidate: IJobCandidateInteractionResponse) =>
        candidate.candidateStatusTags.includes('submitted')
      )
    );
  }, [conversations]);

  const getFieldSettings = async (isMapping) => {
    if (!isMapping) {
      const req = await getSubmissionSettings();
      return req.data;
    }
    return null;
  };

  return (
    <>
      <Box textAlign="center" mt={2}>
        <SwitchButton
          variant="outlined"
          bgColor={planIndex === 0 ? WsColors.TheBlues100 : WsColors.White}
          onClick={() => setPlanIndex(0)}
        >
          Current Submission
        </SwitchButton>
        <SwitchButton
          variant="outlined"
          bgColor={planIndex === 1 ? WsColors.TheBlues100 : WsColors.White}
          onClick={() => setPlanIndex(1)}
        >
          {`${submissions ? `All Submissions (${submissions.length})` : 'All Submissions'}`}
        </SwitchButton>
      </Box>
      {planIndex === 0 ? (
        <>
          {!isEmpty(currentSubmission[0]) && currentSubmission && (
            <Item sx={{ pb: '0px' }}>
              <ActivityCard
                history={history}
                conversation={currentSubmission[0]}
                getFieldSettings={getFieldSettings}
                onActivityUpdate={() =>
                  onActivityUpdate && onActivityUpdate(currentSubmission[0].id)
                }
                loadHistory={loadHistory}
                onClickOnJobCode={(jobId) => onClickOnJobCode && onClickOnJobCode(jobId)}
                onUpdateSubmissionStatus={() =>
                  onSubmissionStatusUpdate && onSubmissionStatusUpdate(currentSubmission[0].id)
                }
                taskLisiting={taskLisiting}
                isInDnc={isInDnc}
                jobAdminTeam={jobAdminTeam}
                loggedInUser={loggedInUser}
                fullView={true}
              />
            </Item>
          )}
          {isEmpty(currentSubmission) && (
            <Stack alignItems="center" mt={20}>
              <WsTypography bold>No Submission Found</WsTypography>
            </Stack>
          )}
        </>
      ) : (
        <>
          {totalConversation &&
            Number(totalConversation) > 5 &&
            submissions.length > 0 &&
            !isLoaded && (
              <Item>
                <TextOnLine>
                  <Link
                    underline="none"
                    onClick={() => {
                      setIsLoaded(true);
                      onLoadMore();
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    Showing latest {submissions.length} conversations. Click here to load more.
                  </Link>
                </TextOnLine>
              </Item>
            )}
          {submissions.map((data, index: number) => (
            <Item key={index} sx={{ pb: '0px' }}>
              <ActivityCard
                history={history}
                conversation={data}
                getFieldSettings={getFieldSettings}
                onActivityUpdate={() => onActivityUpdate && onActivityUpdate(data.id)}
                loadHistory={loadHistory}
                onClickOnJobCode={(jobId) => onClickOnJobCode && onClickOnJobCode(jobId)}
                onUpdateSubmissionStatus={() =>
                  onSubmissionStatusUpdate && onSubmissionStatusUpdate(data.id)
                }
                taskLisiting={taskLisiting}
                isInDnc={isInDnc}
                jobAdminTeam={jobAdminTeam}
                loggedInUser={loggedInUser}
              />
            </Item>
          ))}
          {totalConversation &&
            Number(totalConversation) > 5 &&
            submissions.length > 0 &&
            !isLoaded && (
              <Item>
                <TextOnLine>
                  <Link
                    underline="none"
                    onClick={() => {
                      setIsLoaded(true);
                      onLoadMore();
                    }}
                    sx={{ cursor: 'pointer' }}
                  >
                    Load More
                  </Link>
                </TextOnLine>
              </Item>
            )}
          {submissions.length === 0 && (
            <Stack alignItems="center" mt={20}>
              <WsTypography bold>No Submission Found</WsTypography>
            </Stack>
          )}
        </>
      )}
    </>
  );
};
export default SubmissionHistory;
